<div class="container" #form>
    <div class="row header">
        <div mat-dialog-title style="width: 92%;">
            {{ 'vehicleManagement.addNewVehicle' | translate }}
        </div>
        <div class="icon" (click)="close()">
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<form [formGroup]="vehicleForm">
    <div class="container-fluid">
        <div class="row" style="padding-top: 0.6rem;">
            <div class="col-md-12">
                <div>VIN<span style="color:red">*</span></div>
                <div class="d-flex">
                    <div style="width: 50%;">
                        <mat-form-field appearance="outline">
                            <input  matInput formControlName='vin' type="text"
                                autocomplete="off">
                            <mat-error *ngIf="vehicleForm.controls.vin.errors?.required">
                                {{vehicleForm.controls.vin.errors?.required | translate}}</mat-error>
                            <mat-error *ngIf="vehicleForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric">
                                {{vehicleForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric | translate}}
                            </mat-error>
                            <mat-error *ngIf="vehicleForm.controls.vin.errors?.pattern17Digit">
                                {{vehicleForm.controls.vin.errors?.pattern17Digit | translate}}</mat-error>
                            <mat-error *ngIf="vehicleForm.controls.vin.errors?.patternAlphaNumeric">
                                {{vehicleForm.controls.vin.errors?.patternAlphaNumeric | translate}}</mat-error>
                        </mat-form-field>
                    </div>
                   
                    <div *ngIf="isFetchingData">
                        <app-loading class="staff-master-sync-loading" loadingSymbol="dots" [text]="'Fetching Data'"
                            size=".8" color="var(--dashboard-primary-color)">
                        </app-loading>
                    </div>
                </div>
                <div class="vin-error" *ngIf="isInvalidVin && !isFetchingData && VinField.value?.length === 17">{{ 'vehicleManagement.vehicleDetailsNotFoundPleaseEnterValidVin' | translate }}</div>
                <div class="vin-error" *ngIf="isVinExist && VinField.value?.length === 17">{{ 'vehicleManagement.thisVehicleIsAlreadyAddedToYourTestDriveFleet' | translate }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="field-left">
                    <label>{{ 'testDrive.model' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="model" type="text" [readonly]="validField('model')" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="field-right">
                    <div style="padding-bottom:0.5rem">{{ 'vehicleManagement.modelNumber' | translate }}<span
                            style="color:red">*</span></div>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="trim" type="text" [readonly]="validField('trim')" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="field-start d-grid">
                    <label>{{ 'testDrive.year' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="year" type="text" [readonly]="validField('year')">
                    </mat-form-field>
                </div>
                <div class="field-middle d-grid">
                    <label>{{ 'service.make' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="make" type="text" [readonly]="validField('make')">
                    </mat-form-field>
                </div>
                <div class="field-end d-grid">
                    <label>{{ 'vehicleManagement.color' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <div class="colors"
                            [ngStyle]='{"background-color": vehicleForm.value.exteriorColorHexCode, "border" : vehicleForm.value.exteriorColorHexCode ? "#2E2E2E31 solid 0.5px" : ""}'>
                        </div>
                        <input matInput formControlName="exteriorColorName" type="text" [readonly]="validField('exteriorColorName')">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="modelDescription">
                    <div style="padding-bottom:0.5rem">{{ 'vehicleManagement.marketingTitle' | translate }}<span
                            style="color:red">*</span></div>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="marketingTitle" type="text" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 d-flex">
                <div class="field-left">
                    <label>{{ 'testDrive.stockNo' | translate }}</label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="licensePlate" type="text" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="field-right">
                    <div class="status d-grid">
                        <div class="text">{{ 'servicePersonnel.online' | translate }}<span style="color:red">*</span>
                        </div>
                        <div class="switch">
                            <app-onofswitch [switchInput]="vehicleForm.get('status').value"
                                (switchChange)="updateSwitchValues($event)" [customText]="'Online/Offline'">
                            </app-onofswitch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="controls">
                <h6 *ngIf="clickedOutside" style="color:red;margin:auto;margin-left:1rem;">
                    <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
                    {{'servicePersonnel.alertMessage'| translate}}</h6>
                <div class="cancel" [ngClass]="vehicleForm.dirty ? 'enabled' : ''" (click)="close()">{{
                    'overrideCapacity.cancel' | translate }}</div>
                <div class="save"
                    [ngClass]="vehicleForm.valid && vehicle?.vin === vehicleForm.value.vin && !isVinExist && !isSubmitting ? 'enabled' : ''"
                    (click)="submitForm()">{{ 'overrideCapacity.save' | translate }}</div>
            </div>
        </div>
    </div>

</form>